import { SelectTypeComponent } from './select-type/select-type.component';
import { SmartModalService } from 'app/core/services/smart-modal.service';
import { Subject } from 'rxjs/';
import { RxComponent } from 'app/core/components/common/rx.component';
import { ConfigService } from 'app/core/services/config.service';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import {Observable} from 'rxjs/Observable';
import {TemplatesService} from '../services/templates.service';
import {ActionClickEvent, BulkActionClickEvent} from 'app/shared/components/dynamic-grid/dynamic-grid.component';
import {SimpleInfoComponent} from 'app/shared/components/modal/simple-info.component';
import {MiddlemanService} from 'app/core/services/middleman.service';
import {NotificationService} from 'app/core/services/notification.service';

@Component({
    selector: 'itpx-templates',
    templateUrl: './templates.component.html',
    styleUrls: ['./templates.component.css']
})
export class TemplatesComponent extends RxComponent {

    private url: string;
    private detailsRoute: string = '/organization/communications/templates/{{key}}/edit';
    private fields: Array<any> = [
        {
            title: 'Template Name',
            name: 'key',
            sortable: true,
            config: {
                type: 'template',
                template: 'keyTemplate',
            },
        }, {
            title: 'Subject',
            name: 'subject',
            config: {
                type: 'link',
                route: this.detailsRoute,
                key: 'id'
            },
            sortable: true
        }, {
            title: 'Based on',
            config: {
                type: 'composite',
                format: (item) => this.getDisplayName(item.typeId)
            },
            sortable: true
        }, {
            title: 'Created',
            name: 'createdAt',
            config: {
                type: 'date'
            },
            sortable: true
        }
    ];

    private addNewClicked = new Subject();
    private bulkActionsConfig: any;
    private clearSelection = new Subject<any>();
    private gridRefresh = new Subject<any>();
    private gridClearSelection = new Subject<any>();
    private actionClicked = new Subject<ActionClickEvent>();
    private bulkActionClicked = new Subject<BulkActionClickEvent>();

    constructor(
        private configService: ConfigService,
        private modalService: SmartModalService,
        private middlemanService: MiddlemanService,
        private notificationService: NotificationService,
        private templatesService: TemplatesService,
        private router: Router
    ) {
        super();
        this.url = configService.get('server').url + this.configService.get('endpoints').solar.templates.list.api
            + '?isChunked=true&strictDomain=true';
        this.bulkActionsConfig = {
            key: 'key',
            disableIf: (item) => item.global, //Desabilita o checkbox
            actions: [
                { name: 'delete', label: 'Delete', icon: 'fa-times'}
            ],
            clearSelection : this.clearSelection
        };
    }

    ngOnInit() {

        this.addNewClicked
            .flatMap(() => this.modalService.open(SelectTypeComponent, {}, 'Add New Template').neverError())
            .bindToLifecycle(this)
            .do(_ => console.log('a', _))
            .subscribe(result => this.middlemanService.navigate(
                '/organization/communications/templates/create',
                { action: 'create', type: result.result.key, navigateBack: false }
            ));
    }

    private onAddNewClick() {
        this.addNewClicked.next();
    }

    private getDisplayName(typeId: string): string {
        switch (typeId) {
            case 'solar_class_on_released_to_learner': return 'Class released to learner';
            case 'solar_class_on_released_to_instructor': return 'Class released to instructor';
            default: return '-';
        }
    }

    private onShowMeClick() {
        this.router.navigate(['/support/guides/email-customization'])
    }

    private onDeleteActionClicked(e: BulkActionClickEvent) {
        this.openDeleteConfirmationModal('tm.buyer.messages.confirm-delete', 'Delete Template')
            .subscribe(r => {
                if(r)
                    this.deleteTemplates(e);
            })
    }

    private openDeleteConfirmationModal(text: string, title: string): Observable<any> {
        let result = this.modalService.open(SimpleInfoComponent, {text: text, btn: 'btn-danger', btnYesText: 'Delete'}, title)
            .mapTo(true)
            .catch(_ => Observable.of(false));

        return result;
    }

    private deleteTemplates(e: BulkActionClickEvent){
        this.templatesService.deleteTemplates(e.items)
            .bindToLifecycle(this)
            .subscribe(_ => {
                this.onActionSuccess('Selected template(s) deleted', 'Success');
                this.gridRefresh.next(true);
                this.clearSelection.next(true);
            });
    }

    private onActionSuccess(message: string, title: string) {
        this.notificationService.success(message, title);
        this.gridRefresh.next(true);
    }
}



// WEBPACK FOOTER //
// ./src/app/organization/components/communication/templates/components/templates.component.ts